import React, { useState } from 'react';
import { MapPin, Users, Bed, Building, Tv, Utensils, Sun, Home as HomeIcon, Laptop, ArrowUpDown } from 'lucide-react';
import ImageGallery from './ImageGallery';

const HomeDetails = () => {
  const [showAllPics, setShowAllPics] = useState(false);

  const images = [
    { src: '/images/1.jpg', caption: 'Living room, with large windows allowing in natural light' },
    { src: '/images/2.jpg', caption: 'Our quiet bedroom has a 160cm bed with a comfortable Casper mattress' },
    { src: '/images/3.jpg', caption: 'Dining room, with large table and six chairs' },
    { src: '/images/4.jpg', caption: 'The main bathroom has a toilet, sink, bathtub and integrated shower' },
    { src: '/images/5.jpg', caption: 'The kitchen contains everything you need, including kettle, microwave, dishwasher, cutlery, crockery, pots and pans' },
    { src: '/images/6.jpg', caption: 'Balcony with outside table for two' },
    { src: '/images/7.jpg', caption: 'The living room contains a queen size sofa bed with a premium pull-out memory foam mattress' },
    { src: '/images/8.jpg', caption: 'There is a desk in the bedroom with an ergonomic chair' },
    { src: '/images/9.jpg', caption: 'The guest toilet' },
    { src: '/images/10.jpg', caption: 'The inner courtyard of the listed building' },
    { src: '/images/11.jpg', caption: 'Entrance way of main building' },
  ];

  const address = "Torstraße 138, 10119 Berlin";
  const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;

  return (
    <div className="space-y-4">
      <section>
        <h2 className="text-3xl font-bold mb-2">About Dominic and Florian's Home</h2>
        <p className="text-lg">
          Our apartment in Berlin forms part of a listed <i>Gründerzeit</i> building in the historical centre of the city, 
          benefitting from high ceilings and original features.
        </p>
      </section>

      <section className="mt-2">
        <div className="flex flex-col md:flex-row">
          <div className="space-y-2 md:w-1/2 pb-2 md:pb-0">
            <p className="flex items-center">
              <MapPin className="mr-2" size={20} />
              <a 
                href={googleMapsUrl} 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-blue-600 hover:text-blue-800 underline"
              >
                {address}
              </a>
            </p>
            <p className="flex items-center">
              <Building className="mr-2" size={20} />
              Located at Rosenthaler Platz in the heart of Berlin
            </p>
          </div>
          <div className="space-y-2 md:w-1/2 md:pl-4">
            <p className="flex items-center">
              <Users className="mr-2" size={20} /> 
              Accommodates up to 4 people
            </p>
            <p className="flex items-center">
              <Bed className="mr-2" size={20} /> 
              1 bedroom • 1 bed, 1 sofa bed • 1.5 baths
            </p>
          </div>
        </div>
      </section>

      <section className="mt-2 relative">
        <h3 className="text-2xl font-semibold mb-2">Photos</h3>
        <ImageGallery images={images} showAllPics={showAllPics} setShowAllPics={setShowAllPics} />
        <button
          onClick={() => setShowAllPics(true)}
          className="absolute bottom-4 right-4 bg-white bg-opacity-80 hover:bg-opacity-100 text-gray-800 font-semibold py-2 px-4 rounded-lg shadow-md transition duration-300 ease-in-out transform hover:scale-105"
        >
          All pictures
        </button>
      </section>

      <section className="mt-2">
        <h3 className="text-2xl font-semibold mb-2">Amenities</h3>
        <ul className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <li className="flex items-center"><HomeIcon className="mr-2" size={20} /> Separate living room, dining room and bedroom</li>
          <li className="flex items-center"><Laptop className="mr-2" size={20} /> Fast WiFi and space for two people to work separately</li>
          <li className="flex items-center"><Tv className="mr-2" size={20} /> Home entertainment system</li>
          <li className="flex items-center"><Utensils className="mr-2" size={20} /> Fully equipped kitchen</li>
          <li className="flex items-center"><Sun className="mr-2" size={20} /> Private balcony and shared courtyard</li>
          <li className="flex items-center"><ArrowUpDown className="mr-2" size={20} /> Elevator (must walk down half a flight of stairs)</li>
        </ul>
      </section>
    </div>
  );
};

export default HomeDetails;